import { render } from "./thankyou.vue?vue&type=template&id=605a130a&scoped=true"
import script from "./thankyou.vue?vue&type=script&lang=js"
export * from "./thankyou.vue?vue&type=script&lang=js"

import "./thankyou.vue?vue&type=style&index=0&id=605a130a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-605a130a"

export default script